/**
 * Given a locale code, determine whether the locale language code is of RTL directionality
 * @see {@link https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code} for complete list of languages
 * @param {string} locale - the locale to check
 * @return {boolean} - whether locale language code is of RTL directionality
 */
export default (locale = '') => /^(ar|arc|dv|fa|ha|he|iw|ji|khw|ku|ps|ur|yi)-/.test(locale);
